import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Audio from '../../components/Audio/Audio';
import Text from '../../components/TextWithAudio';

export default function QuestionAudio(_ref) {
  var id = _ref.id,
      audioSource = _ref.audioSource,
      text = _ref.text;

  return React.createElement(
    Fragment,
    null,
    React.createElement(Audio, { id: id, src: audioSource, theme: 'taskQuestion' }),
    text && React.createElement(Text, { text: text })
  );
}

QuestionAudio.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.number.isRequired,
  audioSource: PropTypes.string.isRequired,
  text: PropTypes.string
} : {};

QuestionAudio.defaultProps = {
  text: ''
};